module.exports = function() {
  return new Worker(__webpack_public_path__ + "645e3c15cff455051c73.worker.js");
};